import { OpenTasksCounterVm } from '@/types/backend/models/OpenTasksCounterVm';

const OpenTaskMap = {
  customerContractTaskCount: ['Customer Contract', 'order'],
  siteSurveyTaskCount: ['Site Photos', 'order'],
  utilityBillTaskCount: ['Utility Bill', 'order'],
  deliveryTaskCount: ['Schedule Delivery', 'project'],
  installTaskCount: ['Schedule Install', 'project'],
  roofingInstallTaskCount: ['Complete Install', 'project'],
};

export const mapOpenTasksResponse = (response: { [key: string]: number }): OpenTasksCounterVm[] => {
  const openTasksObj = Object.entries(response)
    .filter(([key]) => key in OpenTaskMap)
    .map(
      ([key, count]) =>
        ({
          count,
          key,
          label: OpenTaskMap[key][0],
          type: OpenTaskMap[key][1],
        } as unknown as OpenTasksCounterVm),
    );

  return openTasksObj;
};
